import {useEffect, useMemo, useState} from 'react';
import {useTranslation} from 'react-i18next';
import Iframe from 'react-iframe';

import {Button, DataWrapper, ExternalLink, InformationModal} from 'components';
import {usePrevious} from 'hooks';
import {TRANSLATION_KEYS} from 'locale';

type Props = {
    open: boolean;
    sessionHistoryKey?: string;
    onClose: () => void;
}

const T_KEYS = TRANSLATION_KEYS.IN_SESSION_PAGE.SIP_MESSAGES_SIDEBAR;

const IBM_IFRAME_BASE_URL = 'https://web-chat.global.assistant.watson.cloud.ibm.com/loadAgentAppFrame.html';

export const IbmMessageHistoryModal: React.FC<Props> = ({open, sessionHistoryKey, onClose}) => {
    const {t} = useTranslation();
    const [iframeLoading, setIframeLoading] = useState(false);
    const prevOpen = usePrevious(open);

    const iframeUrl = useMemo(() => `${IBM_IFRAME_BASE_URL}?session_history_key=${sessionHistoryKey}`, [sessionHistoryKey]);

    useEffect(() => {
        if (open && !prevOpen) {
            setIframeLoading(true);
        }
    }, [open, prevOpen]);

    if (!sessionHistoryKey) {
        return null;
    }

    return (
        <InformationModal
            title={t(T_KEYS.INTEGRATIONS.MODAL.TITLE)}
            fullWidth
            maxWidth='sm'
            open={open}
            onClose={onClose}
        >
            <ExternalLink link={iframeUrl} className='tw-block tw-mb-2'>
                <Button icon='external-link' width='large'>{t(T_KEYS.INTEGRATIONS.MODAL.OPEN_NEW_TAB)}</Button>
            </ExternalLink>
            <div className='tw-relative tw-h-96'>
                <DataWrapper isLoading={iframeLoading} hideContentOnLoading={false}>
                    <Iframe
                        url={iframeUrl}
                        allow='autoplay'
                        height='100%'
                        width='100%'
                        onLoad={() => setIframeLoading(false)}
                    />
                </DataWrapper>
            </div>
        </InformationModal>
    );
};